//
//
//
//
//
//
//
//
//
//
//
import text from './text';
export default {
  data: function data() {
    return {
      text: text
    };
  }
};